import { render } from "./App_Index.vue?vue&type=template&id=afa251bc&ts=true&lang=pug"
import script from "./App_Index.vue?vue&type=script&lang=ts"
export * from "./App_Index.vue?vue&type=script&lang=ts"

import "./App_Index.vue?vue&type=style&index=0&id=afa251bc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/App_Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "afa251bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('afa251bc', __exports__)) {
    api.reload('afa251bc', __exports__)
  }
  
  module.hot.accept("./App_Index.vue?vue&type=template&id=afa251bc&ts=true&lang=pug", () => {
    api.rerender('afa251bc', render)
  })

}


export default __exports__